import { CreateToasterProps } from '@chakra-ui/react';

export enum ToastStatusEnum {
  SUCCESS = 'SUCCESS',
  INFO = 'INFO',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  NOTIFICATION = 'NOTIFICATION',
}

export const defaultToastConfig: CreateToasterProps = {
  placement: 'top-end',
  offsets: '48px',
  duration: 4000,
  pauseOnPageIdle: true,
};

const defaultToastOptions = {
  closable: true,
  duration: 4000,
};

export const successToastOptions = {
  ...defaultToastOptions,
  type: 'success',
  duration: 4000,
};

export const infoToastOptions = {
  ...defaultToastOptions,
  type: 'info',
  duration: 4000,
};

export const warningToastOptions = {
  ...defaultToastOptions,
  type: 'warning',
  duration: 5000,
};

export const errorToastOptions = {
  ...defaultToastOptions,
  type: 'error',
  duration: 9000,
};

export const notificationToastOptions = {
  ...defaultToastOptions,
  type: 'notification',
  duration: 20000,
};
